module.exports = __webpack_public_path__ + "static/media/jet.b9c07106.png";